// Fantasy-RPG "academy" aesthetic: navy stone, antique gold, teal gems.
export const btnPrimary =
  "inline-flex items-center justify-center gap-2 rounded-md bg-gradient-to-b from-[#1a2540] to-[#101830] text-gold-light border border-gold/60 font-semibold uppercase tracking-[0.16em] text-xs px-7 py-3.5 hover:border-gold hover:text-gold-light hover:shadow-[0_0_26px_-4px_rgba(217,164,65,0.55)] active:scale-[0.98] transition-all disabled:opacity-40 disabled:cursor-not-allowed";

export const btnSecondary =
  "inline-flex items-center justify-center gap-2 rounded-md bg-transparent text-zinc-300 border border-zinc-700 font-semibold uppercase tracking-[0.16em] text-xs px-7 py-3.5 hover:border-gold/60 hover:text-gold-light transition-all disabled:opacity-40 disabled:cursor-not-allowed";

export const btnGhost =
  "inline-flex items-center gap-2 rounded-md text-zinc-400 hover:text-gold-light hover:bg-white/5 px-3 py-2 font-medium text-sm transition-colors";

export const card =
  "bg-navy-surface/90 border border-zinc-800 rounded-lg relative shadow-[0_10px_40px_-20px_rgba(0,0,0,0.8)]";

export const cardHover =
  "hover:-translate-y-0.5 hover:border-gold/40 hover:shadow-[0_14px_44px_-16px_rgba(217,164,65,0.25)] transition-all duration-300";

export const input =
  "w-full bg-[#0a1020]/80 border border-zinc-700 text-zinc-100 rounded-md px-4 py-3 focus:outline-none focus:ring-2 focus:ring-gold/40 focus:border-gold/60 transition-all placeholder:text-zinc-600";

export const textarea =
  "w-full bg-[#0a1020]/80 border border-zinc-700 text-zinc-100 rounded-md px-4 py-3 focus:outline-none focus:ring-2 focus:ring-gold/40 focus:border-gold/60 min-h-[180px] transition-all placeholder:text-zinc-600 leading-relaxed";

export const tag =
  "inline-flex items-center rounded px-2 py-1 text-[11px] font-medium border border-zinc-700 text-zinc-400 bg-black/20";

export const tagHi =
  "inline-flex items-center rounded px-2 py-1 text-[11px] font-medium border border-gold/40 text-gold-light bg-gold/10";

export const label =
  "text-[11px] uppercase tracking-[0.28em] text-gold font-semibold";

export const LEVEL_COLORS = {
  intro: "border-gem/40 text-gem-light bg-gem/10",
  core: "border-gold/40 text-gold-light bg-gold/10",
  advanced: "border-rose-500/40 text-rose-300 bg-rose-500/10",
};
